import React from "react";
import { NewsDetailData } from "../../../pages/NewsDetail/types";
import { formatTimestamp } from "../../../utils/helper";
import Image from "next/image";
import { getFullUrl } from "../../../utils/helper";

export const NewsDetailHeader: React.FC<{newsData:NewsDetailData}> = ({
  newsData,
}) => {

  return (
   
    <div className="flex flex-col w-full gap-2 md:w-[698px] md:gap-3">
      {/* Source, avatar */}
      <div className="flex items-center w-fit gap-1">
        {newsData.source.avatar && (
          <Image
            width={20}
            height={20}
            src={getFullUrl(newsData.source.avatar)}
            alt={newsData.source.name}
            className="w-[20px] h-[20px] md:w-8 md:h-8 rounded-full object-cover"
          />
        )}
        <span className="w-[15px] h-[14px] font-[Rubik] font-medium text-[12px] leading-[100%] text-center md:w-[18px] md:h-[18px] md:text-[14px] md:leading-[18px]">
          {newsData.source.name}
        </span>
        </div>

      {/* Headline */}
      <h1 className="font-[Rubik] font-medium text-[18px] leading-[100%] text-left align-middle md:text-[20px] text-gray-900">
        {newsData.headline}
      </h1>

          {/* time stamp */}
      <div className="h-[14px] md:h-[20px] gap-3">
        <span className=" font-[Rubik] font-normal text-[12px] leading-[100%] text-left align-middle md:text-[14px] md:leading-[20px]">
          {formatTimestamp(newsData.timestamp)}
        </span>
      </div>

      {/* Stock Ticker */}
      {newsData?.companies && newsData?.companies?.length <=1 && newsData.stockTicker.name &&
        <div className="w-fit h-[24px] flex felx-col gap-[10px] px-2 py-1 rounded-[20px] border border-gray-200 bg-white md:h-[28] mt-2 md:mt-0">
          <div className="flex items-center w-fit h-[16px] gap-1 md:h-[20px]">
            <span className="h-[16px] font-[Rubik] font-normal text-[12px] leading-[16px] text-center align-middle text-[#1A1A1A] md:h-[20px] md:text-sm md:leading-5">
              {newsData.stockTicker.name}
            </span>
            <span
              className={`font-[Rubik] font-normal text-[12px] leading-[16px] align-middle md:text-sm md:leading-5 ${newsData.stockTicker.changeType === "positive"
                  ? "text-[#067161]"
                  : "text-[#FF0000]"
                }`}
            >
              {newsData.stockTicker.change}
            </span>
          </div>
        </div>
      }
    </div>

  )

};

